import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginPage } from "@/components/pages/LoginPage";
import { getStoredToken, isTokenExpired, setStoredToken } from "@/types";
import type { AuthUser } from "@/types";

export function LoginRoute() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/candidates";

  useEffect(() => {
    const token = getStoredToken();
    if (token && !isTokenExpired(token)) {
      navigate(redirect, { replace: true });
    }
  }, [navigate, redirect]);

  const handleLogin = (_user: AuthUser, token: string) => {
    setStoredToken(token);
    navigate(redirect, { replace: true });
  };

  return <LoginPage onLogin={handleLogin} />;
}
